import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpensePaymentTypes = {
  CREDIT_CARD: 0,
  CASH: 1,
  CHEQUE: 2,
  OTHER: 3,
  CREDIT_CARD_ASSIGNED: 4,
} as const

export type ExpensePaymentTypeEnum = Enum<typeof ExpensePaymentTypes>
